module.exports = {"invalid":"Inválido","invalidEmail":"Email inválido","invalidNumber":"Número inválido","shouldChooseDifferentEmail":"Por favor coloque um email diferente dos emails inseridos acima"}


//////////////////
// WEBPACK FOOTER
// ./src/locale/pt/errors.json
// module id = zzbc
// module chunks = 64